import {ID_FACEBOOK} from "~/utils/constants";

export const useShare = () => {
  const BNTOMessage = useNuxtApp().$BNTOMessage
  /** Facebook **/
  const facebook = ({shareLink}) => {
    // https://developers.facebook.com/docs/sharing/reference/share-dialog
    window.open(`https://www.facebook.com/dialog/share?app_id=${ID_FACEBOOK}&href=${encodeURIComponent(shareLink)}`)
  }
  /** X **/
  const x = ({shareDesc, shareLink}) => {
    // https://developer.x.com/en/docs/x-for-websites/tweet-button/overview
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareDesc)}&url=${encodeURIComponent(shareLink)}`)
  }
  /** instagram **/
  const instagram = ({}) => {
    // https://developers.facebook.com/docs/instagram-platform/sharing-to-feed?locale=zh_CN
    window.open(`https://www.instagram.com/create/story`)
  }
  /** pinterest **/
  const pinterest = ({shareLink, imageUrl, shareDesc}) => {
    window.open(`https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(shareLink)}&media=${encodeURIComponent(imageUrl)}&description=${encodeURIComponent(shareDesc)}`)
  }
  /** downloadImage **/
  const downloadImage = ({imageUrl}) => {
    const a = document.createElement('a');
    a.href = imageUrl;
    a.download = "poster_" + new Date().getTime() + '.png';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  /** copy link **/
  const copyLink = ({shareLink}) => {
    const text = shareLink
    navigator.clipboard.writeText(text).then(() => {
      BNTOMessage.sparkle({
        title: "Link Copied!",
        message: "Now you can share the link to your friends!",
      })
      console.log("Text copied to clipboard!", text);
    }).catch((error) => {
      BNTOMessage.error({message: `Failed to copy text: ${error}`});
      console.error("Failed to copy text:", error);
    });
  }
  /** email **/
  const email = ({shareTitle, shareDesc, shareLink}) => {
    window.open(`mailto:?subject=${shareTitle}&body=${encodeURIComponent(shareDesc + '\n\n' + shareLink)}`);
  }
  /** Message **/
  const message = ({shareDesc, shareLink}) => {
    window.open(`sms:&body=${shareDesc}-${shareLink}`);
  }
  /** more **/
  const more = ({shareTitle, shareDesc, shareLink}) => {
    if (navigator.share) {
      navigator.share({
        title: shareTitle,
        text: shareDesc,
        url: shareLink
      })
        .then(() => console.log('分享成功'))
        .catch(error => console.error('分享失败', error));
    } else {
      BNTOMessage.error({message: `Web Share API is unsupported`});
      console.log('Web Share API 不支持');
    }
  }

  return {
    facebook,
    x,
    instagram,
    pinterest,
    downloadImage,
    copyLink,
    email,
    message,
    more,
  }
}
